<div *ngIf="state.activeCategory as activeCategory; else categoriesList" class="category">
  <lib-category-item></lib-category-item>
  <lib-category-navigation class="navigation"></lib-category-navigation>
  <div class="close-category-btn" (click)="close()">
    <alliance-icon [width]="20" [inheritColor]="true" [name]="ICONS.IconRemoveCross.name"></alliance-icon>
  </div>
</div>

<ng-template #categoriesList>
  <div class="list">
    <div class="santa-flex santa-justify-between">
      <p class="santa-typo-secondary-bold">{{ translations.title | translate }}</p>
      <alliance-icon (click)="close()" class="close" [width]="20" [inheritColor]="true" [name]="ICONS.IconRemoveCross.name"></alliance-icon>
    </div>
    <div
      *ngFor="let category of CATEGORIES; trackBy: trackByFn"
      class="santa-border-0 santa-border-b santa-border-solid santa-border-black-600 santa-border-opacity-20 santa-cursor-pointer santa-mt-10 santa-pb-10"
      (click)="activateCategory(category)"
    >
      <div class="santa-flex santa-space-x-10">
        <alliance-icon [name]="ICONS_BY_CATEGORY_MAP[category]"></alliance-icon>
        <div>
          <p class="santa-typo-additional-bold santa-leading-20 santa-text-black-700">
            {{ translations.categories.titles[category] | translate }}
          </p>
          <p class="santa-typo-additional santa-leading-20 santa-text-black-600">
            {{ translations.categories.descriptions[category] | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
